import {DateRange} from "react-day-picker";
import {endOfWeek, isAfter, startOfWeek} from "date-fns";
import {SetURLSearchParams} from "react-router-dom";

const dateRangeParamFrom = "from";
const dateRangeParamTo = "to";

const getDefaultRange = (): DateRange => ({
    from: startOfWeek(new Date()),
    to: endOfWeek(new Date())
});

export const searchParamsToDateRange = (searchParams: URLSearchParams): DateRange => {
    const searchParamFrom = searchParams.get(dateRangeParamFrom);
    const searchParamTo = searchParams.get(dateRangeParamTo);
    if (!searchParamFrom || !searchParamTo) {
        return getDefaultRange();
    }

    const from = new Date(searchParamFrom);
    const to = new Date(searchParamTo);
    if (!Number(from.valueOf())
        || !Number(to.valueOf())
        || !isAfter(to, from)) {
        return getDefaultRange();
    }

    return {from, to};
};

export const setSearchParamsDateRange = (updated: DateRange, setSearchParams: SetURLSearchParams) => {
    setSearchParams(p => {
        if (!updated.from || !updated.to) {
            p.delete(dateRangeParamFrom);
            p.delete(dateRangeParamTo);
            return p;
        }

        p.set(dateRangeParamFrom, updated.from.toISOString());
        p.set(dateRangeParamTo, updated.to.toISOString());
        return p;
    });
};
